import { render, staticRenderFns } from "./3STrend.vue?vue&type=template&id=5924b6d4&"
import script from "./3STrend.vue?vue&type=script&lang=js&"
export * from "./3STrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports